import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ViewModule} from '../../../../bing-maps/view/view.module';
import { LibraryListComponent } from './library-list.component';
import {ApplicationPipesModule} from '../../../../application-pipes-module/application-pipes.module';
import {FormsModule} from '@angular/forms';
import { LibraryItemComponent } from '../library-item/library-item.component';


@NgModule({
    imports: [
        CommonModule,
        ViewModule,
        FormsModule,
        ApplicationPipesModule,
    ],
  declarations: [LibraryListComponent, LibraryItemComponent],
  exports: [LibraryListComponent, LibraryItemComponent]
})

export class LibraryListModule {}
